import { render } from "./DashboardNFTs.vue?vue&type=template&id=65f73512&scoped=true"
import script from "./DashboardNFTs.vue?vue&type=script&lang=js"
export * from "./DashboardNFTs.vue?vue&type=script&lang=js"

import "./DashboardNFTs.vue?vue&type=style&index=0&id=65f73512&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65f73512"]])

export default __exports__